webpackJsonp([0],[
/* 0 */,
/* 1 */,
/* 2 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Hello__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Hello___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_Hello__);




__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  mode: 'history',
  routes: [{
    path: '/health/yiji',
    name: 'home',
    component: __WEBPACK_IMPORTED_MODULE_2__components_Hello___default.a
  }]
}));

/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(11)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(6),
  /* template */
  __webpack_require__(19),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 4 */,
/* 5 */,
/* 6 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'app'
});

/***/ }),
/* 7 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__loading__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__loading___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__loading__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




// import { MessageBox } from 'element-ui'
/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      yiTitle: '',
      yiDesc: '',
      jiTitle: '',
      jiDesc: '',
      yiji: {},
      fullscreenLoading: true, // londing
      winHeight: 667,
      logoB: false,
      yijiconent: ''
    };
  },

  components: {
    loading: __WEBPACK_IMPORTED_MODULE_1__loading___default.a
  },
  methods: {
    yijiData: function yijiData() {
      var _this = this;

      this.winHeight = window.screen.height - 100;
      var tizhi = this.$route.query.tizhi;
      var gender = this.$route.query.gender;
      var yjData = this.url + 'day/yiji?gender=' + gender + '&tizhi=' + tizhi;
      this.$http.get(yjData).then(function (response) {
        _this.yiji = response.data.data;
        // this.yiji =
        // console.log(JSON.parse(response.data).data)
        __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].prototype.yijiconent = _this.yiji.n_month + _this.yiji.n_day + '   宜：' + _this.yiji.yi.title + '   忌：' + _this.yiji.ji.title;
        _this.yiTitle = _this.yiji.yi.title;
        _this.jiTitle = _this.yiji.ji.title;
        _this.yiDesc = _this.yiji.yi.desc;
        _this.jiDesc = _this.yiji.ji.desc;
        _this.fullscreenLoading = false;
      }).catch(function (response) {
        console.log(response);
      });
    }
  },
  mounted: function mounted() {
    this.yijiData();
  }
});

/***/ }),
/* 8 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({});

/***/ }),
/* 9 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__App__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_resource__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_weixin_js_sdk__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_weixin_js_sdk___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_weixin_js_sdk__);
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.




__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].config.productionTip = false;
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_3_vue_resource__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].prototype.url = 'https://api.huofar.com/v61/7.0/';
// console.log(Vue.prototype.yijiconent)
/* eslint-disable no-new */

new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
  el: '#app',
  http: __WEBPACK_IMPORTED_MODULE_3_vue_resource__["a" /* default */],
  router: __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */],
  template: '<App/>',
  components: { App: __WEBPACK_IMPORTED_MODULE_1__App___default.a }
});

var loveCookie = function loveCookie(cname) {
  var name = cname + '=';
  var ca = document.cookie.split(';');
  for (var i = 0; i < ca.length; i++) {
    var c = ca[i];
    while (c.charAt(0) === ' ') {
      c = c.substring(1);
    }if (c.indexOf(name) !== -1) return c.substring(name.length, c.length);
  }
  return '';
};
var loveId = loveCookie('hf_appId');
var loveTimestamp = loveCookie('hf_timestamp');
var loveStr = loveCookie('hf_nonceStr');
var loveSignature = loveCookie('hf_signature');
__WEBPACK_IMPORTED_MODULE_4_weixin_js_sdk___default.a.config({
  debug: false,
  appId: loveId, // 和获取Ticke的必须一样------必填，公众号的唯一标识
  timestamp: loveTimestamp, // 必填，生成签名的时间戳
  nonceStr: loveStr, // 必填，生成签名的随机串
  signature: loveSignature, // 必填，签名，见附录1
  // 需要分享的列表项:发送给朋友，分享到朋友圈，分享到QQ，分享到QQ空间
  jsApiList: ['onMenuShareAppMessage', 'onMenuShareTimeline']
});

// 处理验证成功的信息
__WEBPACK_IMPORTED_MODULE_4_weixin_js_sdk___default.a.ready(function () {
  var conent = __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].prototype.yijiconent;
  // console.log(conent)
  // 分享到朋友圈
  __WEBPACK_IMPORTED_MODULE_4_weixin_js_sdk___default.a.onMenuShareTimeline({
    title: '今日宜忌',
    desc: conent, // 描述
    link: window.location.href, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
    imgUrl: 'http://img.huofar.com/images/guoriziLogo.png',
    trigger: function trigger(res) {
      // ***
    },
    success: function success(res) {},
    cancel: function cancel(res) {},
    fail: function fail(res) {}
  });
  // 分享给朋友
  __WEBPACK_IMPORTED_MODULE_4_weixin_js_sdk___default.a.onMenuShareAppMessage({
    title: '今日宜忌',
    desc: conent, // 描述
    link: window.location.href, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
    imgUrl: 'http://img.huofar.com/images/guoriziLogo.png',
    trigger: function trigger(res) {
      // ***
    },
    success: function success(res) {},
    cancel: function cancel(res) {},
    fail: function fail(res) {}
  });
  __WEBPACK_IMPORTED_MODULE_4_weixin_js_sdk___default.a.error(function (res) {});
});

/***/ }),
/* 10 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 11 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 12 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/loading.28a250e.gif";

/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/logo.137d7e8.png";

/***/ }),
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/title-logo.8adfcaa.png";

/***/ }),
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(12)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(7),
  /* template */
  __webpack_require__(20),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(10)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(8),
  /* template */
  __webpack_require__(18),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 18 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "loading"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(13),
      "alt": ""
    }
  })])
}]}

/***/ }),
/* 19 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('router-view')], 1)
},staticRenderFns: []}

/***/ }),
/* 20 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "clearfix"
  }, [_c('div', {
    staticClass: "t clearfix"
  }, [_c('div', {
    staticClass: "border",
    style: ({
      'min-height': _vm.winHeight + 'px'
    })
  }, [_c('div', {
    staticClass: "top"
  }), _vm._v(" "), _c('div', {
    staticClass: "center-date"
  }, [_c('h1', [_vm._v(_vm._s(_vm.yiji.Day))]), _vm._v(" "), _c('h4', [_vm._v(_vm._s(_vm.yiji.year) + "/" + _vm._s(_vm.yiji.month))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.yiji.week))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.yiji.n_year) + "年 " + _vm._s(_vm.yiji.n_month) + " " + _vm._s(_vm.yiji.n_day))])]), _vm._v(" "), _c('div', {
    staticClass: "bottom-content"
  }, [_c('div', {
    staticClass: "content-list border-one"
  }, [_c('h3', {
    staticClass: "list-title clearfix"
  }, [_c('span', {
    staticClass: "list-icon-yi"
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.yiTitle))])]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.yiDesc))])])]), _vm._v(" "), _c('div', {
    staticClass: "bottom-content"
  }, [_c('div', {
    staticClass: "content-list"
  }, [_c('h3', {
    staticClass: "list-title-two clearfix"
  }, [_c('span', {
    staticClass: "list-icon-two"
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.jiTitle))])]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.jiDesc))])])])])]), _vm._v(" "), _c('div', {
    staticClass: "logo",
    on: {
      "click": function($event) {
        _vm.logoB = !_vm.logoB
      },
      "touchmove": function($event) {
        $event.preventDefault();
      }
    }
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(14),
      "alt": ""
    }
  })]), _vm._v(" "), (_vm.logoB) ? _c('div', {
    staticClass: "logoBg",
    on: {
      "click": function($event) {
        _vm.logoB = false
      },
      "touchmove": function($event) {
        $event.preventDefault();
      }
    }
  }, [_vm._m(0)]) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "logoTxt"
  }, [_c('div', {
    staticClass: "logo-title clearfix"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(15),
      "alt": ""
    }
  }), _vm._v(" "), _c('span', [_vm._v("简介")])]), _vm._v(" "), _c('p', [_vm._v(" 致力于倡导新中式健康生活，与你一同，感受身心节律，体验四时之美，换一种更自然的活法儿。"), _c('br'), _c('br'), _vm._v("\n          2007年成立至今，已有超过3000万用户使用了活法儿提供的“中医体质测试”、 “节气体质调理”等免费服务。旗下共有”过日子“等6款APP，全面覆盖饮食调养、月经调理、调体备孕、小病小痛等生活健康领域。")])])
}]}

/***/ }),
/* 21 */,
/* 22 */,
/* 23 */,
/* 24 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ })
],[9]);


// WEBPACK FOOTER //
// static/js/app.53cb8735a98383004a9d.js